<template>
	<div class="wrapper_bg">
		<div class="wrapper">
			<top-info :loanInfo="loan_info"></top-info>
			<div class="des">
				<div @click="gotoPse">
					Le recomendamos que use PSE para pagar, el costo es más bajo y el depósito es más rápido.
					<span>Realice su pago a tiempo le ayudará a aumentar el monto de su préstamo.</span>
				</div>
				<img src="@/assets/image/internal/payment/pago_three.webp" alt="" class="pago_three" />
			</div>
			<div class="top">
				<div class="span">Fecha de pago</div>
				<div class="time">
					<div
						:style="{
							color: orderHomeInfo.order_status == 9 ? '#F5404D' : '#9053F7',
						}"
						class="repay_date"
					>
						{{ stagesObject.repayDate }}
						<div v-if="orderHomeInfo.order_status == 9" class="tips">
							Se ha atrasado <b>{{ orderHomeInfo.overdueDays }}</b> día(s)
							<p class="bto_icon"></p>
						</div>
					</div>
					<button @click="getDetails">
						Detalles
					</button>
				</div>
				<div class="span">
					<span>Resto por pagar: &nbsp;</span>
					<span>$ {{ addComma(stagesObject.repayAmount) }}</span>
				</div>
				<img
					src="@/assets/image/internal/payment/tip_other.webp"
					alt=""
					class="tip_other"
					v-if="orderHomeInfo.order_status == 9"
				/>
				<div class="line"></div>
			</div>

			<com-coupon
				ref="couponRef"
				:couponData="couponData"
				:confirmarShow.sync="confirmarShow"
				:stagesObject.sync="stagesObject"
				:orderHomeInfo="orderHomeInfo"
				:oldRepayAmount="oldRepayAmount"
				@confirmarEmit="confirmarEmit"
				@newStringEmit="newStringEmit"
				tip="payment"
			></com-coupon>

			<div class="title" style="margin:.34rem  0  .2rem">
				Elegir un método de pago
			</div>
			<!-- is_show：1 show 0 hide -->
			<div v-for="(item, index) in dataInfo" :key="index" @click="handleType(item)">
				<div v-if="item.is_show == 1">
					<div class="bottom">
						<div>
							<img :src="item.icon" alt="" class="pago_one" />
							<span>{{ item.name }}</span>
							<img
								v-if="item.is_recommend == 1"
								src="@/assets/image/internal/payment/good_icon.webp"
								alt=""
								class="good_icon"
							/>
						</div>
						<div>
							<img src="@/assets/image/internal/payment/right_icon.webp" alt="" class="pago_three" />
						</div>
						<img src="@/assets/image/internal/payment/tip.webp" alt="" class="tip" v-if="item.is_reduction == 1" />
					</div>
					<div class="bottom_title">
						{{ item.content }}
					</div>
				</div>
			</div>
			<swipe-info :bannerList="bannerList"></swipe-info>
			<!-- Confirm Coupon Popup -->
			<van-dialog v-model="confirmarShow" :show-confirm-button="false">
				<div v-if="confirmarObject.confirmarCouponType == 1 || confirmarObject.confirmarCouponType == 9">
					<p>
						Solo se puede usar 1 cupón de descuento a lo máximo en cada pedido.
					</p>
					<p>
						¿Está seguro de usar el cupón de
						<span v-if="confirmarObject.confirmarCouponType == 9">
							$
							{{ confirmarObject.confirmarDistributeType == 1 ? confirmarObject.confirmarSendAmount : newString }}
						</span>
						<span v-else-if="confirmarObject.confirmarCouponType == 1">
							$ {{ addComma(confirmarObject.confirmarSendAmount) }} </span
						>?
					</p>
				</div>
				<div v-else-if="confirmarObject.confirmarCouponType == 8">
					<div>
						Solo se puede usar 1 cupón de reducción de comisión a lo máximo en cada pedido.
					</div>
					<div>¿Está seguro de usarlo?</div>
				</div>
				<button class="button_right" @click="handleSumbit">CONFIRMAR</button>
				<button class="button_cerrar" @click="handleCerrar">Cerrar</button>
			</van-dialog>

			<!-- Click on the convenience store pop-up window -->
			<van-dialog
				v-model="efectivoShow"
				:show-cancel-button="true"
				confirm-button-text="PSE"
				cancel-button-text="Efectivo"
				class="efectiveClass"
				@confirm="handleEfectivoConfirm()"
				@cancel="handleEfectivoCancel(efectivoItem)"
			>
				{{ pseGuide.description }}
			</van-dialog>

			<van-popup round v-model="detailsShow" position="bottom" :close-on-click-overlay="false">
				<div class="detailsClass">
					<h3>Detalles del préstamo</h3>
					<img
						class="close_btn"
						src="@/assets/image/internal/initialconfirm/coupon_eight.png"
						alt=""
						@click="getDetails"
					/>
					<div>
						<span>Pago total</span>
						<div style="padding: 0; align-items: center;">
							<span
								:style="[
									orderHomeInfo.total_amount_due != orderHomeInfo.total_coupon_amount
										? { 'text-decoration': 'line-through', 'font-size': '.26rem' }
										: '',
								]"
							>
								$ {{ addComma(orderHomeInfo.total_amount_due) }}</span
							>
							<span v-if="orderHomeInfo.total_amount_due != orderHomeInfo.total_coupon_amount"
								>&nbsp; $ {{ addComma(orderHomeInfo.total_coupon_amount) }}</span
							>
						</div>
					</div>
					<div>
						<span>Monto depositado</span>
						<span>$ {{ addComma(orderHomeInfo.loan_amount) }}</span>
					</div>
					<div>
						<span>Fecha de pago</span>
						<span>{{ addComma(orderHomeInfo.repay_time) }}</span>
					</div>
					<!-- <div>
        <span>Tarifa de servicio Cloud</span>
        <span>$ {{ addComma(orderHomeInfo.fixedDiscount) }}</span>
      </div> -->
					<!-- <div>
        <span>Descuento</span>
        <span>$ {{ addComma(orderHomeInfo.totalDiscountAmount) }}</span>
      </div> -->
					<div>
						<span>Tarifa de servicio Cloud</span>
						<span>
							<span style="text-decoration:line-through">$ 300,000</span>
							{{ orderHomeInfo.service_fee ? '$ ' + addComma(orderHomeInfo.service_fee) : '' }}
						</span>
					</div>
					<!-- <div>
        <span>IVA</span>
        <span>$ {{ addComma(orderHomeInfo.vat) }}</span>
      </div> -->
					<div>
						<span>Interés@25% e.a</span>
						<span>$ {{ addComma(orderHomeInfo.interest) }}</span>
					</div>
					<div v-if="orderHomeInfo.order_status == 9 && orderHomeInfo.penalty_amount">
						<span>Interés moratorio</span>
						<span style="color: #F5404D;">$ {{ addComma(orderHomeInfo.penalty_amount) }}</span>
					</div>
					<div v-if="orderHomeInfo.coupon_amount">
						<span>Cupón</span>
						<span>$ {{ addComma(orderHomeInfo.coupon_amount) }}</span>
					</div>
					<div v-if="orderHomeInfo.reduction">
						<span>Monto reducido</span>
						<span>$ {{ addComma(orderHomeInfo.reduction) }}</span>
					</div>
					<div>
						<span>Monto pagado</span>
						<span>$ {{ addComma(orderHomeInfo.paid_amount) }}</span>
					</div>
				</div>
			</van-popup>
		</div>
	</div>
</template>

<script>
	import common from '@/mixins/common.js'
	import comCoupon from '@/components/internal/coupon.vue'
	import topInfo from '@/components/internal/topInfo.vue'
	import { timeFunction, addComma } from '@/utils/internal'
	import swipeInfo from '@/components/internal/swipeInfo.vue'

	export default {
		mixins: [common],
		components: {
			topInfo,
			swipeInfo,
			comCoupon,
		},
		data() {
			return {
				dataInfo: {},
				confirmarShow: false,
				bannerList: [],
				efectivoShow: false,
				oldRepayAmount: null,
				orderHomeInfo: {},
				detailsShow: false,
				stagesObject: {},
				loan_info: {},
				pseGuide: {},
				efectivoItem: {},
				couponData: {},
				confirmarObject: {},
				newString: '',
				detailShow: false,
			}
		},
		mounted() {
			this.getAccessToken()
			this.getApiHead()
			this.refreshPage()
			window.refreshPage = this.refreshPage
		},
		methods: {
			timeFunction,
			addComma,

			refreshPage() {
				this.getOrderHome()
				this.getCoupon({ coupon_type: 6 })
				this.getRepayInfo()
				this.getLoanInfo('', true)
				this.getGetBanner({ bannerType: 3 })
			},
			gotoPse() {
				window.android?.openUrl(`${this.url}/h5/pseGuide/index.html`)
			},
			//获取确认后的优惠券数据
			confirmarEmit(value) {
				this.confirmarObject = value
			},
			//优惠券确认弹窗中显示金额
			newStringEmit(value) {
				this.newString = value
			},
			//Obtain repayment method
			getRepayInfo(value) {
				this.$axios
					.post(this.apiHeadGatewayVh + 'getRepayInfo', {
						...this.params,
						...value,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.dataInfo = JSON.parse(res.data.data)
							console.log('dataInfo------', this.dataInfo)
						}
					})
			},
			//pick up information
			getOrderHome() {
				this.$axios
					.post(this.apiHeadGatewayVh + 'ucenter/order/home', {
						...this.params,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.orderHomeInfo = res.data.data.info
							this.stagesObject = res.data.data.stages_list[0]
							this.oldRepayAmount = this.stagesObject.repayAmount
							this.$refs.couponRef.confirmarObject = {
								confirmarSendAmount: this.orderHomeInfo.coupon_amount,
								confirmarCouponType: 1,
							}
						}
					})
			},
			//Click Type
			handleType(item) {
				if (item.name.includes('Efectivo')) {
					this.$axios
						.post(this.apiHeadGatewayVh + 'payment/pseGuide', {
							...this.params,
						})
						.then((res) => {
							if (res.data.code == 0) {
								this.pseGuide = JSON.parse(res.data.data)

								if (this.pseGuide.isOpen == 1) {
									this.efectivoShow = true
									this.efectivoItem = item
								} else {
									this.handleEfectivoCancel(item)
								}
							}
						})
				} else if (item.name.includes('PSE')) {
					this.pseHref(item)
				}
			},
			//Click on the convenience store confirmation pop-up window
			handleEfectivoConfirm() {
				//Identify the first item that meets the criteria
				if (this.dataInfo) {
					let array = this.dataInfo.find((i) => {
						if (i.is_show == 1 && i.name.includes('PSE')) return i
					})
					this.pseHref(array)
				}
			},

			//Jump to different pse pages
			pseHref(item) {
				//is_expand == 0 Jumping less

				console.log(
					`${item.is_expand == 0 ? '/nequi' : '/pse'}?repayAmount=${this.stagesObject.repayAmount}&channelNo=${
						item.code
					}&paymentType=${item.paymentType}&orderId=${this.orderHomeInfo.order_id_str}&reduction=${
						item.is_reduction
					}&name=${item.name}`,
				)
				window.android.openUrl(
					`${this.url}${item.is_expand == 0 ? '/nequi' : '/pse'}?repayAmount=${
						this.stagesObject.repayAmount
					}&channelNo=${item.code}&paymentType=${item.paymentType}&orderId=${
						this.orderHomeInfo.order_id_str
					}&reduction=${item.is_reduction}&name=${item.name}`,
				)

				// window.open(
				//   `http://localhost:8080${
				//     item.is_expand == 0 ? "/nequi" : "/pse"
				//   }?repayAmount=${this.stagesObject.repayAmount}&channelNo=${
				//     item.code
				//   }&paymentType=${item.paymentType}&orderId=${
				//     this.orderHomeInfo.order_id_str
				//   }&reduction=${item.is_reduction}&name=${item.name}`
				// );
			},
			//Click on the convenience store to cancel the pop-up window
			handleEfectivoCancel(item) {
				console.log(
					`${this.url}/efectivo?repayAmount=${this.stagesObject.repayAmount}&channelNo=${item.code}&paymentType=${item.paymentType}&orderId=${this.orderHomeInfo.order_id_str}&reduction=${item.is_reduction}&name=${item.name}`,
				)
				window.android.openUrl(
					`${this.url}/efectivo?repayAmount=${this.stagesObject.repayAmount}&channelNo=${item.code}&paymentType=${item.paymentType}&orderId=${this.orderHomeInfo.order_id_str}&reduction=${item.is_reduction}&name=${item.name}`,
				)
				// window.open(
				//   `http://localhost:8080/efectivo?repayAmount=${this.stagesObject.repayAmount}&channelNo=${item.code}&paymentType=${item.paymentType}&orderId=${this.orderHomeInfo.order_id_str}&reduction=${item.is_reduction}&name=${item.name}`
				// );
			},

			//Confirm Coupon
			handleSumbit() {
				this.$axios
					.post(this.apiHeadGatewayVh + 'payment/coupon/payment_coupon', {
						coupon_id: this.confirmarObject.confirmarId,
						type: 2,
						...this.params,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.refreshPage()
							this.handleCerrar()
						}
					})
			},
			//Cancel Coupon
			handleCerrar() {
				this.confirmarShow = false
				this.$refs.couponRef.confirmarObject = {
					confirmarSendAmount: null,
				}
			},
			getDetails() {
				this.detailsShow = !this.detailsShow
			},
		},
	}
</script>
<style lang="scss" scoped>
	@import '@/assets/style/internal/payment/index.scss';
	@import '@/assets/style/internal/toast.scss';

	.wrapper {
	}
</style>
